import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { MatTabGroup } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSelect } from '@angular/material/select';
import { lastValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { ChangeRequestsService } from 'src/app/services/change-requests.service';
import { MainService } from 'src/app/services/main.service';
import { ChangeRequestsAddEditComponent } from '../shared/dialogs/change-requests-add-edit/change-requests-add-edit.component';
import { ChangeRequestsHistoryComponent } from '../shared/dialogs/change-requests-history/change-requests-history.component';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-change-requests',
  templateUrl: './change-requests.component.html',
  styleUrls: ['./change-requests.component.scss']
})
export class ChangeRequestsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  @ViewChild('statusSelect') statusSelect!: MatSelect;

  isLoading = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  displayedColumns: string[] = ['select', 'id', 'id_code', 'titulo', 'descripcion','nombre_creador', 'nombre_responsable', 'badges', 'status', 'created_at', 'estimated_date', 'last_interaction', 'last_interaction_date', 'actions'];
  allSolicitudes: any[] = [];

  statusSelected = 0;
  selectedRequests = new Set<number>();
  massiveStatus: number | null = null;
  editingStatusRowId: number | null = null;

  countTotal = 0;
  countPendientes = 0;
  countEnProceso = 0;
  countTerminadas = 0;
  allBadges: any[] = [];
  allUsers: any[] = [];

  constructor(
    private main: MainService,
    private changeRequestsService: ChangeRequestsService,
    private cdr: ChangeDetectorRef,
    private matDialog: MatDialog,
    private userService: UsersService,

  ) {}

  ngOnInit(): void {
    this.loadAllSolicitudes();
    this.loadInitialData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.cdr.detectChanges();
  }

  hasPermissions(){
   return this.userService.isBuhoUsr();
  }

  loadInitialData(): void {
    this.changeRequestsService.getBadges().subscribe((res: any) => { 
      if (res.message === 'Success' && res.data) {
        this.allBadges = res.data;
      }
    });
    this.userService.getUserList().subscribe((res: any) => {

        console.log("usrs",res);
        this.allUsers = res;
      
    });
  }

  loadAllSolicitudes() {
    this.main.ShowLoading();
    this.changeRequestsService.getSolicitudes({ status: '0' }).subscribe({
      next: (res: any) => { 
        const data = res.data || [];
        const requests = data.map((req: any) => {
          try {
            req.parsed_badges = req.badges ? JSON.parse(req.badges) : [];
          } catch (e) {
            req.parsed_badges = [];
          }
          return req;
        });

        this.allSolicitudes = requests;
        this.updateCounters(requests);
        this.filterSolicitudesByStatus(this.statusSelected);
        this.main.HideLoading();
      },
      error: (err : any) => {
        this.main.HideLoading();
        Swal.fire('Error', 'No se pudo obtener la lista.', 'error');
      }
    });
  }

  getSolicitudes(status: number) {
    this.statusSelected = status;
        this.selectedRequests.clear();
        this.massiveStatus = null;
    this.filterSolicitudesByStatus(status);
  }

  filterSolicitudesByStatus(status: number) {
    this.dataSource.data = status === 0 ? this.allSolicitudes : this.allSolicitudes.filter(req => req.status === status);
  }

  updateCounters(requests: any[]): void {
    this.countTotal = requests.length;
    this.countPendientes = requests.filter(req => req.status === 1).length;
    this.countEnProceso = requests.filter(req => req.status === 2).length;
    this.countTerminadas = requests.filter(req => req.status === 3).length;
  }

  openAddEditDialog(request?: any): void {
    const dialogRef = this.matDialog.open(ChangeRequestsAddEditComponent, {
      panelClass: ['dialogs-md'],
      data: {
        request: request ? { ...request } : null, 
        allBadges: this.allBadges,
        allUsers: this.allUsers
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.reload) {
        this.loadAllSolicitudes();
      }
    });
  }

  openHistory(request: any): void {
    console.log("req for history", request.id);
    this.matDialog.open(ChangeRequestsHistoryComponent, {
      panelClass: ['dialogs-md'],
      data: {
        id_solicitud: request.id
      }
    });
  }


  async changeMassiveStatus() {
    if (this.selectedRequests.size === 0 || this.massiveStatus === null) {
      Swal.fire('Atención', 'Seleccione elementos y un estatus.', 'warning');
      return;
    }

    const { isConfirmed } = await Swal.fire({
      title: '¿Cambiar estatus?',
      text: `Se actualizarán ${this.selectedRequests.size} solicitudes.`,
      icon: 'question',
      showCancelButton: true
    });

    if (isConfirmed) {
      this.main.ShowLoading();
      try {
        const requestsToUpdate = Array.from(this.selectedRequests);
        const statusName = this.getStatusName(this.massiveStatus);

        const promises = requestsToUpdate.map(id => 
          lastValueFrom(this.changeRequestsService.setSolicitudStatus({
            id_solicitud: id,
            status: this.massiveStatus!,
            status_name: statusName
          }))
        );

        await Promise.all(promises);
        Swal.fire('Éxito', 'Solicitudes actualizadas.', 'success');
        this.selectedRequests.clear();
        this.massiveStatus = null;
        this.loadAllSolicitudes();
      } catch (error) {
        Swal.fire('Error', 'Error al actualizar.', 'error');
        this.main.HideLoading(); 
      }
    }
  }

  changeStatus(request: any, newStatus: number) {
    this.main.ShowLoading();
    const statusName = this.getStatusName(newStatus);
    this.changeRequestsService.setSolicitudStatus({
      id_solicitud: request.id,
      status: newStatus,
      status_name: statusName
    }).subscribe({
      next: (res: any) => {
        this.main.HideLoading();
        if (res.message === 'Success') {
          Swal.fire('Éxito', 'El estatus se ha actualizado correctamente.', 'success');
          this.editingStatusRowId = null;
          this.loadAllSolicitudes();
        } else {
          Swal.fire('Error', 'No se pudo actualizar el estatus.', 'error');
        }
      },
      error: (err:any) => {
        this.main.HideLoading();
        Swal.fire('Error', 'Ocurrió un error al cambiar el estatus.', 'error');
        console.error(err);
      }
    });
  }

  startEditingStatus(request: any) {
    if (request.status != 3 && this.hasPermissions()){
       this.editingStatusRowId = request.id; 
       setTimeout(() => {
         this.statusSelect?.open();
       });
    }

  }

  cancelEditingStatus() {
    this.editingStatusRowId = null;
  }

  getStatusName(status: number): string {
    const statuses: { [key: number]: string } = { 1: 'Pendiente', 2: 'En Proceso', 3: 'Terminada' };
    return statuses[status] || 'Desconocido';
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  isAllSelected() {
    const selectableRows = this.dataSource.data.filter(row => row.status !== 3);
    const numSelected = this.selectedRequests.size;
    const numSelectableRows = selectableRows.length;
    return numSelected === numSelectableRows && numSelectableRows > 0;
  }

  masterToggle() {
    const selectableRows = this.dataSource.data.filter(row => row.status !== 3);
    if (this.isAllSelected()) {
      this.selectedRequests.clear();
      return;
    }
    selectableRows.forEach(row => this.selectedRequests.add(row.id));
  }

  toggleSelection(row: any) {
    this.selectedRequests.has(row.id) ?
      this.selectedRequests.delete(row.id) :
      this.selectedRequests.add(row.id);
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selectedRequests.has(row.id) ? 'deselect' : 'select'} row ${row.id}`;
  }


  async deleteRequest(id_solicitud: number) {
    const { isConfirmed } = await Swal.fire({
      title: '¿Está seguro?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (isConfirmed) {
      this.main.ShowLoading();
      this.changeRequestsService.deleteSolicitud(id_solicitud).subscribe({
        next: (res: any) => {
          this.main.HideLoading();
          if (res.message === 'Success') {
            Swal.fire('Eliminada', 'La solicitud ha sido eliminada.', 'success');
            this.loadAllSolicitudes(); // Recargar la lista
          } else {
            Swal.fire('Error', 'No se pudo eliminar la solicitud.', 'error');
          }
        },
        error: (err: any) => {
          this.main.HideLoading();
          Swal.fire('Error', 'Ocurrió un error al eliminar la solicitud.', 'error');
          console.error(err);
        }
      });
    }
  }

   downloadExcel(){
    this.main.ShowLoading();
    setTimeout(() => {
      const dataToPrint = this.dataSource.filteredData.map(row => {
        const obj_req: any = {};
        obj_req.ID = row.id;
        obj_req.Título = row.titulo;
        obj_req.Descripción = row.descripcion;
        obj_req.Solicitante = row.nombre_creador;
        obj_req.Responsable = row.nombre_responsable || 'No asignado';
        obj_req.Estatus = this.getStatusName(row.status);
        obj_req['Fecha creación'] = this.formatDate(row.created_at);
        obj_req['Fecha compromiso'] = this.formatDate(row.estimated_date) || 'No definida';
        obj_req['Última interacción'] = row.last_interaction || 'Sin interacción';
        obj_req['Fecha últ. interacción'] = this.formatDate(row.last_interaction_date) || '-';
        return obj_req;
      });

      let fileName = "Solicitudes";
      if (this.statusSelected === 0) {
        fileName = "Solicitudes generales";
      } else {
        const statusName = this.getStatusName(this.statusSelected)+"s";
        fileName = `Solicitudes ${statusName.toLowerCase()}`;
      }

      this.main.generateExcel(dataToPrint, fileName);
      this.main.HideLoading();
    }, 20);
  }

    formatDate(date: string) {
    if(!date) return 
    const fechaEntrega = date == null?  " " : date.replace(/undefined-/g, '');
    const fecha = fechaEntrega.split(' ');
    const sinHora = fecha[0];
    const fechaObj = new Date(sinHora);
    const anio = fechaObj.getFullYear();
    const mes = (fechaObj.getMonth() + 1).toString().padStart(2, '0');
    const dia = fechaObj.getUTCDate().toString().padStart(2, '0');

    return `${anio}-${mes}-${dia}`;
  }
}